// Don't initialize add-ons inside the Shopify Theme Editor
if (window.Shopify && Shopify.designMode) {
  console.log('Skipping product add-ons in Theme Editor');
} else {
  initAllProductAddOns();
  document.addEventListener('DOMContentLoaded', initAllProductAddOns);
  document.addEventListener('shopify:section:load', initAllProductAddOns);
}
const BALLOON_VARIANT_ID = '43214899806285';
const BANNER_VARIANT_ID = '43509155594317';

function syncPanels(root) {
  root.querySelectorAll('[data-addon-panel]').forEach((panel) => {
    const key = panel.dataset.addonPanel;
    const toggle = root.querySelector(`[data-addon-toggle="${key}"]`);
    const isOpen = !!toggle && (toggle.type === 'radio' ? toggle.checked : toggle.checked);
    panel.classList.toggle('is-open', isOpen);
    panel.setAttribute('aria-hidden', isOpen ? 'false' : 'true');

    const bannerMessage = panel.querySelector('[data-banner-message]');
    if (bannerMessage) {
      if (isOpen) bannerMessage.setAttribute('required', 'required');
      else bannerMessage.removeAttribute('required');
    }
  });
}

function getMainQuantity(form) {
  const quantityInput = form.querySelector('input[name="quantity"]');
  const quantity = Number(quantityInput?.value || 1);
  return Number.isFinite(quantity) && quantity > 0 ? quantity : 1;
}

async function addSelectedAddOns(form, root, mainQuantity) {
  const items = [];
  const productTitle = root.dataset.productTitle || 'Main item';

  const bannerToggle = root.querySelector('[data-addon-toggle="banner"]');
  if (bannerToggle?.checked) {
    const message = root.querySelector('[data-banner-message]')?.value?.trim() || '';
    items.push({
      id: Number(BANNER_VARIANT_ID),
      quantity: mainQuantity,
      properties: {
        'Add-on for': productTitle,
        'Banner Message': message,
      },
    });
  }

  const balloonsToggle = root.querySelector('[data-addon-toggle="balloons"]');
  if (balloonsToggle?.checked) {
    const occasion = root.querySelector('[data-balloon-occasion]')?.value || '';
    items.push({
      id: Number(BALLOON_VARIANT_ID),
      quantity: mainQuantity,
      properties: {
        'Add-on for': productTitle,
        'Balloon Occasion': occasion,
      },
    });
  }

  const stuffedToggle = root.querySelector('[data-addon-toggle="stuffed-animal"]');
  if (stuffedToggle?.checked) {
    const select = root.querySelector('[data-stuffed-animal-variant]');
    const variantId = select?.value;
    const priceRange = select?.selectedOptions?.[0]?.dataset?.label || select?.selectedOptions?.[0]?.textContent?.trim() || '';
    if (variantId) {
      items.push({
        id: Number(variantId),
        quantity: mainQuantity,
        properties: {
          'Add-on for': productTitle,
          'Stuffed Animal Price Range': priceRange,
        },
      });
    }
  }

  if (!items.length) return null;

  const cartItemsComponents = document.querySelectorAll('cart-items-component');
  const sectionIds = [];
  cartItemsComponents.forEach((item) => {
    if (item instanceof HTMLElement && item.dataset.sectionId) sectionIds.push(item.dataset.sectionId);
  });

  const response = await fetch('/cart/add.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json',
    },
    body: JSON.stringify({
      items,
      sections: sectionIds.join(','),
    }),
  });

  const data = await response.json();
  if (!response.ok || data.status) {
    throw new Error(data.description || data.message || 'Unable to add selected add-ons.');
  }
  return data;
}

function initProductAddOns(root) {
  if (root.dataset.addonsInitialized === 'true') return;
  root.dataset.addonsInitialized = 'true';

  root.addEventListener('change', (event) => {
    if (event.target?.matches?.('[data-addon-toggle], [data-celestial-banner-choice]')) syncPanels(root);
  });
  syncPanels(root);

  const productFormComponent = root.closest('product-form-component');
  const form = productFormComponent?.querySelector('form');
  if (!form) return;

  form.addEventListener('submit', () => {
    const mainQuantity = getMainQuantity(form);
    window.__fantasyPendingProductAddOns = {
      formId: form.getAttribute('id') || '',
      promise: addSelectedAddOns(form, root, mainQuantity).catch((error) => {
        console.error(error);
        alert(error.message || 'Unable to add selected add-ons. Please try again.');
        throw error;
      }),
    };
  }, true);
}

function initAllProductAddOns() {
  document.querySelectorAll('[data-product-add-ons]').forEach(initProductAddOns);
}
